








































import { Component, Inject, Mixins, Watch } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import {
  nokoService,
  ListData,
  ProgressFormData,
  CompetitionFormData,
  inviteService,
} from '@/services';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import Infotext from '@/components/parts/infotext';
import { IsProgressFormOpenMixin } from '@/pages/profile/mixins';
import store from '@/pages/profile/store';
import { fromUtc } from '@/tools/formatedate';
import { OpenForm } from '@/pages/profile/components';
import { Header, Result, NokoFilter } from './components';
import { progressStore } from './forms/ProgressStore';
import { mapItems } from '@/tools/mapitems';
import { IProgress, StatusEnum, InfoTextEnum } from './types';
import { returnStatement } from 'babel-types';

@Component({
  components: {
    LoadingSpinner,
    Infotext,
    Header,
    Result,
    OpenForm,
    NokoFilter,
  },
  metaInfo: () => ({
    title: 'Достижения',
  }),
})
export default class Progress
  extends Mixins(IsProgressFormOpenMixin)
  implements IProgress {
  @Inject() $api: ApiInstance;

  progressList: ListData = [];
  studentsList: any = [];
  status = StatusEnum.PREPARE;
  infoText = InfoTextEnum.NO_KIDS;

  competitionId: string = '';
  studentId: string = '';

  get id(): string {
    return store.state.id;
  }

  get state() {
    return this.$store.state;
  }

  get competition() {
    const { nokoCompetitionList } = this.state;
    return mapItems(nokoCompetitionList);
  }

  get isError() {
    return this.status === StatusEnum.ERROR;
  }

  get isLoading() {
    return this.status === StatusEnum.LOADING;
  }

  get isReady() {
    return this.status !== StatusEnum.PREPARE;
  }

  get user() {
    return this.$store.state.user;
  }

  get name(): string {
    const { children } = this.user;
    if (!isArrayNotEmpty(children)) return '';
    const result = children.find(({ id }: { id: string }) => id === this.id);
    return result ? result.first_name : '';
  }

  get siteUserId(): string {
    const { profile } = this.user;
    return profile && profile.id;
  }

  get resultForSelectedChild(): ListData {
    const { progressList } = this;
    return progressList;
  }

  @Watch('siteUserId', { immediate: true })
  isSiteUserId(val: string) {
    if (val) {
      this.getProgressList();
    }
  }

  mounted() {
    this.getStudents();
  }

  competitionIdChange(val: string) {
    this.competitionId = val;
    this.getProgressList();
  }

  studentIdChange(val: string) {
    this.studentId = val;
    this.getProgressList();
  }

  form(value: string = 'add'): void {
    let root = 'profile';
    let centerRoute = '';
    if (this.$route.name) {
      let split = this.$route.name.split('-');
      if (split.length >= 3) {
        centerRoute = split[split.length - 2];
      }
    }
    this.$router.push({
      name: `${root}${centerRoute ? '-' + centerRoute : ''}-${value}`,
    });
  }

  async getStudents() {
    try {
      const { data } = await inviteService(this.$api).getCurrentUsers();
      const users = data;
      if (users.length) {
        this.studentsList = mapItems(users, true);
      } else {
        this.studentsList = [];
      }
    } catch (err) {
      this.processError(err);
    }
  }

  async getProgressList(): Promise<void> {
    let { siteUserId, competitionId, studentId } = this;
    let siteUserIdParam = '';
    if (!studentId) {
      siteUserIdParam = siteUserId;
    }
    this.status = StatusEnum.LOADING;
    try {
      const { data } = await nokoService(this.$api).getProgressList(
        siteUserIdParam,
        competitionId,
        studentId,
      );
      this.progressList = data;
      this.status = StatusEnum.SUCCESS;
    } catch (err) {
      this.processError(err);
    }
  }

  async submitProgress(payload: ProgressFormData): Promise<void> {
    if (payload) {
      this.status = StatusEnum.LOADING;
      this.form('progress');
      try {
        const result = await nokoService(this.$api).postProgress(payload);
        this.getProgressList();
        progressStore.cleanProgressState();
      } catch (err) {
        this.processError(err);
      }
    }
  }

  async submitCompetitionForm(payload: CompetitionFormData) {
    const { $store } = this;
    if (payload) {
      const { name, level } = payload;
      try {
        const { data } = await nokoService(this.$api).postCompetition(payload);
        $store.commit('addNokoCompetitionList', { id: data.id, name, level });
        progressStore.addCompetition(data.id);
        this.form('add');
      } catch (err) {
        this.processError(err);
      }
    }
  }

  resetList() {
    this.progressList = [];
  }

  processError(err: any = {}) {
    this.resetList();
    this.status = StatusEnum.ERROR;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/Progress.vue